export default __webpack_public_path__ + "static/media/automationicon.d692b921.svg";